import React from "react";

/** Styles d’actions : voir `heroActionClasses.ts` (`adminHeroActionClassName`, etc.). */

export type AdminPageHeroProps = {
  eyebrow?: string;
  title: string;
  subtitle: string;
  actions?: React.ReactNode;
};

/**
 * Bandeau héro réutilisable (gradient, blob, titres) — aligné sur le Command Center dashboard.
 */
export function AdminPageHero({
  eyebrow,
  title,
  subtitle,
  actions,
}: AdminPageHeroProps): React.JSX.Element {
  return (
    <section className="relative overflow-hidden rounded-2xl border border-slate-800 bg-gradient-to-br from-slate-900 via-slate-900 to-emerald-950/40 p-5 shadow-xl md:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="relative flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div>
          {eyebrow ? (
            <p className="text-xs font-semibold uppercase tracking-widest text-emerald-400/90">
              {eyebrow}
            </p>
          ) : null}
          <h1 className="mt-1 text-2xl font-bold tracking-tight text-white md:text-3xl">{title}</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-400">{subtitle}</p>
        </div>
        {actions ? (
          <div className="flex w-full flex-row flex-wrap items-center gap-2 justify-start sm:justify-end lg:w-auto lg:flex-shrink-0 lg:justify-end">
            {actions}
          </div>
        ) : null}
      </div>
    </section>
  );
}
